export const LOST_DAMAGED_PALLETS_ITEM_PREFIX = 'LOST_DAMAGED_PALLETS_ITEM';
export const SEND_PALLETS_ITEM_PREFIX = 'SEND_PALLETS_ITEM';
export const PALLETS_ITEM_PREFIX = 'PALLETS_ITEM';
export const ADDITIONAL_CHARGE_PREFIX = 'ADDITIONAL_CHARGE';
export const COMMERCIAL_NETWORK_ITEM_PREFIX = 'COMMERCIAL_NETWORK_ITEM';
